export enum UserRole {
  ADMIN = 'admin',
  EMPLOYER = 'employer',
  EMPLOYEE = 'employee',
  CONTRACTOR = 'contractor',
  ORGANISATION_OWNER = 'organisation_owner',
  INVOICE_MANAGER = 'invoice_manager',
  EMPLOYMENT_MANAGER = 'employment_manager',
  ORGANISATION_ADMIN = 'organisation_admin',
}

export const ALLOWED_INCORPORATION_COUNTRIES = [
  'AU',
  'BE',
  'BG',
  'CY',
  'DE',
  'IE',
  'MT',
  'PH',
  'HK',
  'HR',
  'US',
  'GB',
  'SE',
  'UK',
] as const;
